import { proxy } from "valtio";
import {
  createDefaultEventSchedule,
  Editor,
  editorState,
  WebsiteStore,
} from "./editor";
import { Guest } from "../types/guest";

export const GuestDrawerStore = proxy<{
  isAddGuestDrawerOpen: boolean;
  isEditGuestDrawerOpen: boolean;
  drawerCtx: "add_guest" | "edit_guest";
  selectedGuest: Guest | null;
  isInsightsModalOpen: boolean;
  refreshLoading: boolean;
  deleteLoading: boolean;
}>({
  isAddGuestDrawerOpen: false,
  isEditGuestDrawerOpen: false,
  drawerCtx: "add_guest",
  selectedGuest: null,
  isInsightsModalOpen: false,
  refreshLoading: false,
  deleteLoading: false,
});

export const onAddGuestDrawerOpen = (cb?: () => void) => {
  if (cb) cb?.();
  GuestDrawerStore.isAddGuestDrawerOpen = true;
  GuestDrawerStore.drawerCtx = "add_guest";
};

export const onAddGuestDrawerClose = (cb?: () => void) => {
  if (cb) cb?.();
  GuestDrawerStore.isAddGuestDrawerOpen = false;
};

export const onEditGuestDrawerOpen = (cb?: () => void) => {
  if (cb) cb?.();
  GuestDrawerStore.isEditGuestDrawerOpen = true;
  GuestDrawerStore.drawerCtx = "edit_guest";
};

export const onEditGuestDrawerClose = (cb?: () => void) => {
  if (cb) cb?.();
  GuestDrawerStore.isEditGuestDrawerOpen = false;
  GuestDrawerStore.selectedGuest = null;
};

export const onEventScheduleDrawerClose = () => {
  editorState.currentEventSchedule = createDefaultEventSchedule();
  WebsiteStore.isEventScheduleDrawerOpen = false;
  if (GuestDrawerStore.drawerCtx === "add_guest") {
    onAddGuestDrawerOpen();
  } else {
    onEditGuestDrawerOpen();
  }
};

export const getEventTypeFromEditor = (eventID: string, editor: Editor) => {
  const event = editor.eventSchedules?.find((ev) => ev._id === eventID);
  return event?.eventType;
};

export const onInsightsModal = (state: "open" | "close") => () => {
  GuestDrawerStore.isInsightsModalOpen = state === "open";
};
